import React, { useRef } from 'react';
import { IonAlert, IonButton, IonButtons, IonHeader, IonIcon, IonText, IonToolbar, useIonAlert, useIonRouter } from '@ionic/react';
import LogoutIcon from '../shared/assets/icons/logout.svg';
import DishIcon from '../shared/assets/icons/dish.svg';
import { clearAll } from '../core/preference';
import { logoutStaff } from '../entities/auth/api/logout';

const HeaderComponent: React.FC = () => {
  const alert = useRef<HTMLIonAlertElement>(null);
  const router = useIonRouter()
  const logOut = async ()=>{
    try {
      const res = await logoutStaff()
      console.log("Logout", res)
      await  clearAll()
      alert.current?.dismiss();
      router.push('/auth',"root", "replace")
    } catch (error) {
      console.log("Logout error", error)
    }
    
  }
  return (
    <>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot='start'>
            <IonIcon icon={DishIcon} className=" ml-2 mr-2 h-[30px]" />
            <IonText className="!text-[#000]">Waiter App</IonText>
          </IonButtons>
          <IonButtons slot='end'>
            <IonButton>Online</IonButton>
            <IonButton id="present-alert" onClick={()=>alert.current?.present()}><IonIcon icon={LogoutIcon} /></IonButton>
          </IonButtons>
        </IonToolbar>

      </IonHeader>
      <IonAlert
        // header="Alert!"
        ref={alert}
        message="Что Вы хотите выйти?"
        trigger="present-alert"
        buttons={[
          {
            text: 'Нет',
            role: 'cancel',
            handler: () => {
              alert.current?.dismiss();
              console.log('Alert canceled');
            },
          },
          {
            text: 'Да',
            role: 'confirm',
            handler: () => {
              
                logOut();
       
            },
          },
        ]}
        onDidDismiss={({ detail }) => console.log(`Dismissed with role: ${detail.role}`)}
      ></IonAlert>
    </>


  );
};

export default HeaderComponent;
